import Docs from "./docs";
export default Docs